import React from 'react';
import './Cali.css'; 

const SanAndres = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKSP.pdf" target="_blank" rel="noreferrer">Aeropuerto Gustavo Rojas Pinilla</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 06</th>                      
          </tr>                
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/DAGA1G.pdf" target="_blank" rel="noreferrer">DAGA1G</a></th>
          </tr>   
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/DAGA1G.pdf" target="_blank" rel="noreferrer">LEVO1G</a></th>
          </tr>  
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/DAGA1G.pdf" target="_blank" rel="noreferrer">TIMR1G</a></th>
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/SSP1A.pdf" target="_blank" rel="noreferrer">SSP1A</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/NIKL1A.pdf" target="_blank" rel="noreferrer">NIKL1A</a></th>
          </tr> 
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/NIKL1A.pdf" target="_blank" rel="noreferrer">MUDA1A</a></th>
          </tr> 
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/NIKL1A.pdf" target="_blank" rel="noreferrer">ODOV1A</a></th>
          </tr> 
          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 24</th>                      
          </tr>
         
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1H.pdf" target="_blank" rel="noreferrer">AMUB1H</a></th>
          </tr>  
            <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1H.pdf" target="_blank" rel="noreferrer">DURA1H</a></th>
          </tr> 
            <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1H.pdf" target="_blank" rel="noreferrer">UGEV1H</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/SSP1A.pdf" target="_blank" rel="noreferrer">SSP1A</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/GEKE1A.pdf" target="_blank" rel="noreferrer">GEKE1A</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/GEKE1A.pdf" target="_blank" rel="noreferrer">ISMO1A</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/GEKE1A.pdf" target="_blank" rel="noreferrer">VUPG1A</a></th>
          </tr> 
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 06</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">AMUB2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">BIXO2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">BODE2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">DAGA2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">DURA2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">FALL2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">LEVO2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">PELR2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">TIMR2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2E.pdf" target="_blank" rel="noreferrer">UGEV2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">AMUB1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">BIXO1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">DAGA1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">DURA1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">FALL1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">LEVO1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">PELR1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">TIMR1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">TOSA1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB1G.pdf" target="_blank" rel="noreferrer">UGEV1G</a></th>
          </tr>

          
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 24</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">AMUB2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">BIXO2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">BODE2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">DAGA2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">DURA2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">FALL2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">LEVO2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">PELR2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">TIMR2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/AMUB2F.pdf" target="_blank" rel="noreferrer">UGEV2F</a></th>
          </tr>
         
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 06</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/RNP06.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/VORY06.pdf" target="_blank" rel="noreferrer">VOR Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/VORZ06.pdf" target="_blank" rel="noreferrer">VOR Z</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 24</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/RNP24.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/VORY24.pdf" target="_blank" rel="noreferrer">VOR Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSP/VORZ24.pdf" target="_blank" rel="noreferrer">VOR Z</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default SanAndres;